export default "__VITE_ASSET__5953daae__"